import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"list\"><defs><style>#list .cls-1{fill:none}</style></defs><title>资源 72</title><g id=\"list_图层_2\" data-name=\"图层 2\"><g id=\"list_图层_1-2\" data-name=\"图层 1\"><path id=\"list_Rectangle_45_Copy_18\" data-name=\"Rectangle 45 Copy 18\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"list_bars\"><path id=\"list_Shape\" d=\"M3 18a1.48 1.48 0 1 1 1.47 1.48A1.47 1.47 0 0 1 3 18zm5.48.68a.85.85 0 0 1 0-1.69h11.67a.85.85 0 1 1 0 1.69zM3 12a1.48 1.48 0 1 1 1.47 1.48A1.47 1.47 0 0 1 3 12zm5.48.68a.85.85 0 0 1 0-1.69h11.67a.85.85 0 1 1 0 1.69H8.48zM3 6a1.48 1.48 0 1 1 1.47 1.49A1.47 1.47 0 0 1 3 6zm5.48.68a.84.84 0 0 1-.84-.85.83.83 0 0 1 .84-.83h11.67a.84.84 0 0 1 .85.84.85.85 0 0 1-.85.85z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/list.svg
// module id = lFS3
// module chunks = 6